"use client";
import React, { useState, useMemo } from 'react';
import { FaSearch } from 'react-icons/fa';
import OrderCard from './OrderCard';

const OrdersContent = ({
  title = "Orders",
  tabs = [],
  activeTab,
  onTabChange,
  orders = [],
  onOrderClick = null
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredOrders = useMemo(() => {
    if (!searchQuery.trim()) return orders;

    return orders.filter(order =>
      order.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.items.some(item =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      ) ||
      order.status.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [orders, searchQuery]);

  const handleSearch = (e) => {
    e.preventDefault();
  };

  const handleOrderClick = (order) => {
    if (onOrderClick) {
      onOrderClick(order);
    }
  };

  return (
    <main className="ml-5 w-[73%] p-6 max-md:ml-0 max-md:w-full">
      <div className="w-full max-md:mt-8 max-md:max-w-full">
        <header className="flex gap-2.5 items-center py-1.5 text-2xl font-bold text-center whitespace-nowrap border-b border-black border-opacity-10 min-h-12 text-sky-950">
          <h2 className="self-stretch my-auto text-sky-950">{title}</h2>
        </header>

        <section className="flex flex-col px-5 py-5 mt-7 w-full bg-white rounded-2xl shadow-2xl max-md:max-w-full">
          {tabs.length > 0 && (
            <div className="flex gap-3 self-center p-1.5 max-w-full text-base whitespace-nowrap bg-white rounded-3xl border border-solid border-slate-300 w-[339px]">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => onTabChange(tab.key)}
                  className={`flex flex-col justify-center items-start px-9 py-2.5 font-medium rounded-2xl max-md:px-5 ${
                    activeTab === tab.key
                      ? 'border border-indigo-400 border-solid bg-indigo-400 bg-opacity-10 text-sky-950'
                      : 'bg-zinc-300 bg-opacity-10 text-slate-600'
                  }`}
                >
                  <span className={activeTab === tab.key ? 'text-sky-950' : 'opacity-80 text-slate-600'}>
                    {tab.label}
                  </span>
                </button>
              ))}
            </div>
          )}

          <form onSubmit={handleSearch} className="flex items-center gap-3 px-12 py-3 mt-4 text-sm leading-loose text-black bg-white rounded-3xl border border-solid shadow-sm border-slate-200 max-md:px-5 max-md:max-w-full">
            <FaSearch className="text-gray-400 w-4 h-4 flex-shrink-0" />
            <input
              type="search"
              placeholder="Find your order"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="flex-1 bg-transparent border-none outline-none text-black placeholder-black placeholder-opacity-50"
              aria-label="Search orders"
            />
          </form>

          <div className="space-y-4 mt-4">
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order, index) => (
                <div
                  key={order.id}
                  onClick={() => handleOrderClick(order)}
                  className={onOrderClick ? "cursor-pointer hover:shadow-lg transition-shadow duration-200" : ""}
                >
                  <OrderCard
                    orderId={order.id}
                    items={order.items}
                    status={order.status}
                    orderDate={order.orderDate}
                    deliveredDate={order.deliveredDate}
                    returnedDate={order.returnedDate}
                  />
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                No orders found matching your search.
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default OrdersContent;
